// app/javascript/components/TestButton.jsx

import React from "react";
import {Button} from "./ui/button";

function TestButton() {
    return (
        <Button className="bg-red-600 text-black p-4 rounded-full">
            Test Button
        </Button>
    );
}

export default TestButton;
